import { render, staticRenderFns } from "./copy-conversation-dialog.vue?vue&type=template&id=2210406a&scoped=true&"
import script from "./copy-conversation-dialog.vue?vue&type=script&lang=js&"
export * from "./copy-conversation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210406a",
  null
  
)

export default component.exports